
import NotesMaxView from "./NotesMaxView";

export default NotesMaxView;